import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import PlayerInterestDialog from "@/components/site/PlayerInterestDialog";
import { NAV, INTEREST } from "@/constants/testIds";

const links = [
  { id: NAV.linkAbout, href: "#about", label: "About" },
  { id: NAV.linkPrograms, href: "#programs", label: "Programs" },
  { id: NAV.linkTravel, href: "#travel", label: "Travel Teams" },
  { id: NAV.linkTestimonials, href: "#testimonials", label: "Voices" },
  { id: NAV.linkContact, href: "#contact", label: "Contact" },
];

export default function Nav({ barVisible = true }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      style={{ top: barVisible ? "2.5rem" : "0" }}
      className={`fixed inset-x-0 z-50 transition-[top,background-color] duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050B14]/85 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid={NAV.logo}
          className="flex items-center gap-3 group"
        >
          <img
            src="/brand/bba-logo.png"
            alt="Team BBA Elite"
            className="h-11 w-auto drop-shadow-[0_0_18px_rgba(184,197,214,0.15)]"
          />
          <div className="leading-tight hidden sm:block">
            <div className="font-display text-base tracking-tight">
              BLEDSOE
            </div>
            <div className="text-[10px] tracking-[0.3em] text-[#A0ABC0]">
              BASKETBALL ACADEMY
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={l.id}
              className="text-sm text-white/80 hover:text-[#B8C5D6] transition-colors tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <PlayerInterestDialog
            testId={INTEREST.navTrigger}
            trigger={
              <button
                type="button"
                data-testid={NAV.ctaJoin}
                className="btn-gold px-5 py-3 text-sm uppercase"
              >
                Player Interest
              </button>
            }
          />
        </div>

        <button
          type="button"
          aria-label="Toggle menu"
          data-testid={NAV.mobileToggle}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid={NAV.mobileMenu}
          className="md:hidden border-t border-white/10 bg-[#050B14]/95 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base text-white/85 hover:text-[#B8C5D6]"
              >
                {l.label}
              </a>
            ))}
            <PlayerInterestDialog
              trigger={
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="btn-gold px-5 py-3 text-sm uppercase text-center mt-2 w-full"
                >
                  Player Interest
                </button>
              }
            />
          </div>
        </div>
      )}
    </header>
  );
}
